import type { IContextMutationResult } from '@modules/core/services/query/types';
import { useRestClient } from '@modules/core/services/api';
import { useContextMutation } from '@modules/core/services/query';
import { useToastStore } from '@modules/toast/store';

import type { ICreateRolePayload, ICreateRoleResponse } from '../types';
import {
  CREATE_ROLE_API_URL,
  CREATE_ROLE_MUTATION,
  ROLES_AND_TREE_QUERY,
  ROLES_PERMISSIONS,
} from '../constants';

export default function useCreateRoleMutation(): IContextMutationResult<
  ICreateRoleResponse,
  Error,
  ICreateRolePayload
> {
  const { fetchPost } = useRestClient();
  const { displayPresetToast } = useToastStore();

  return useContextMutation<ICreateRoleResponse, Error, ICreateRolePayload>({
    mutationKey: [CREATE_ROLE_MUTATION],
    mutationFn: (payload) => fetchPost<ICreateRoleResponse>(
      CREATE_ROLE_API_URL,
      payload,
      { permission: ROLES_PERMISSIONS.ROLES_CREATE },
    ),
    async onSuccess({ queryClient }) {
      await queryClient.invalidateQueries({ queryKey: [ROLES_AND_TREE_QUERY] });
      displayPresetToast('edited');
    },
  });
}
